/**
 * Devises supportées par le système comptable
 * Aligné avec le backend accounting-service
 */
export const CURRENCIES = {
  CDF: {
    code: 'CDF',
    name: 'Franc Congolais',
    symbol: 'FC',
    default: true,
    decimals: 2
  },
  USD: {
    code: 'USD',
    name: 'Dollar américain',
    symbol: '$',
    default: false,
    decimals: 2
  },
  EUR: {
    code: 'EUR',
    name: 'Euro',
    symbol: '€',
    default: false,
    decimals: 2
  },
  GBP: {
    code: 'GBP',
    name: 'Livre Sterling',
    symbol: '£',
    default: false,
    decimals: 2
  },
  ZAR: {
    code: 'ZAR',
    name: 'Rand Sud-Africain',
    symbol: 'R',
    default: false,
    decimals: 2
  },
  XAF: {
    code: 'XAF',
    name: 'Franc CFA CEMAC',
    symbol: 'FCFA',
    default: false,
    decimals: 0
  },
  XOF: {
    code: 'XOF',
    name: 'Franc CFA UEMOA',
    symbol: 'FCFA',
    default: false,
    decimals: 0
  },
  CNY: {
    code: 'CNY',
    name: 'Yuan Chinois',
    symbol: '¥',
    default: false,
    decimals: 2
  }
} as const;

export type CurrencyCode = keyof typeof CURRENCIES;

export function formatCurrency(amount: number, currency: CurrencyCode = 'CDF'): string {
  return new Intl.NumberFormat('fr-CD', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0
  }).format(amount);
}

export function formatCompactCurrency(amount: number, currency: CurrencyCode = 'CDF'): string {
  const millions = amount / 1000000;
  return `${millions.toFixed(1)}M ${CURRENCIES[currency].symbol}`;
}